export const css = {
	root: 'FkxWlF_9',
	title: '_2WwU7OsD',
	wrapper: 'XsZ4M3Xz',
	field: '_2gPQWOUd',
	bar: '_3WXgqY3B',
	target: '_3aWotEAy',
	barscore: 'ziF95ysS',
	' _key': 'prepost-viz/target-viz'
};

export default css;
